import React from 'react'
import { IoLogoInstagram, IoLogoGithub, IoShareSocialOutline, IoMail } from 'react-icons/io5';
import styled from 'styled-components';
import { Link  } from 'react-router-dom';
const Footer = () => {
  
  const title = document.title;
  const url = document.location.href;
  function handleShare() {
    if (navigator.share) {
      navigator
        .share({ title, url })
        .then(() => {
          console.log("Thanks For sharing!");
        })
        .catch(console.error);
    } else {
      if (
        window.confirm(
          "Sorry, your browser or device does not support sharing URLs. \nDo you want to copy the URL to your clipboard instead?"
        )
      ) {
        navigator.clipboard.writeText(window.document.location.href);
        alert("Link copied to clipboard!");
      }
    }
  };
  
  return (
    
      <StyledFooter>
        <footer>
          <FooterSection>
            <SocialMedia>
              <SocialLink href="https://instagram.com/ayushsolanki.exe?igshid=NzMyMjgxZWIzNw==">
                <IoLogoInstagram />
              </SocialLink>
              <SocialLink href="https://github.com/ayushsolanki29">
                <IoLogoGithub />
              </SocialLink>
              <SocialLink href="mailto:desirestore.help@gmail.com">
                <IoMail />
              </SocialLink>
              <SocialLink style={{ cursor: 'pointer' }} onClick={handleShare}>
                <IoShareSocialOutline />
              </SocialLink>
            </SocialMedia>

            <List>
            <ListItem>
                <Link to="/">Home</Link>
              </ListItem>
              <ListItem>
                <Link to="/about">About</Link>
              </ListItem>
              <ListItem>
                <Link to="/policy">Policy</Link>
              </ListItem>
             
              <ListItem>
                <Link to="/developer">Developer</Link>
              </ListItem>
            </List>

            <Copyright>
              &copy; 2023 Universal Chat
            </Copyright>

            <Author>
              <AuthorText>Made with ❤️ by Ayush Solanki</AuthorText>
            </Author>
          </FooterSection>
        </footer>
      </StyledFooter>
   
  );

};
const StyledFooter = styled.div`
  font-weight: 400;
  user-select: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: #fff;
`;

const FooterSection = styled.section`
  padding: 40px 0;
`;

const SocialMedia = styled.div`
  text-align: center;
  padding-bottom: 25px;
  user-select: none;
`;

const SocialLink = styled.a`
  font-size: 24px;
  color: inherit;
  border: 1px solid #ccc;
  width: 40px;
  height: 40px;
  line-height: 50px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  margin: 0 8px;
  opacity: 0.75;

  &:hover {
    opacity: 0.9;
  }
`;

const List = styled.ul`
  margin-top: 0;
  padding: 0;
  list-style: none;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 0;
  text-align: center;

  @media screen and (max-width: 420px) {
    li {
      display: block;
    }
  }
`;

const ListItem = styled.li`
  display: inline-block;
  padding: 0 15px;
  cursor:pointer;
   a{
    color: inherit;
    text-decoration: none;
    opacity: 0.8;
   }
`;

const Copyright = styled.p`
  margin-top: 15px;
  text-align: center;
`;

const Author = styled.div`
  margin-top: 12px;
  display: block;
  width: 100%;
  height: 100%;
`;

const AuthorText = styled.p`
  text-align: center;
`;
export default Footer;